module.exports = __webpack_public_path__ + "img/logo1.3866ec47.png";